/**
 * ToggleUserSettingUseCase
 *
 * Toggles a user setting on/off with optimistic local update.
 * Delegates to UserSettingsService which handles:
 * 1. Optimistic local storage update
 * 2. Cloud function call
 * 3. Revert on failure
 */

import { UserSettingsService } from '@/domain/services/settings/userSettingsService';

export class ToggleUserSettingUseCase {
  private userSettingsService: UserSettingsService;

  constructor(userSettingsService?: UserSettingsService) {
    this.userSettingsService = userSettingsService || new UserSettingsService();
  }

  async execute(settingName: string): Promise<boolean> {
    return await this.userSettingsService.toggleUserSetting(settingName);
  }
}

export const toggleUserSettingUseCase = new ToggleUserSettingUseCase();
